<div class="container" *ngIf="false">
  <div class="row my-3">
    <div class="col">
      <div class="bg-white rounded-3 shadow">
        <ul class="nav align-items-center">
          <li class="nav-item">
            <a href="/" class="nav-link ">Home</a>
          </li>
          <li class="">/</li>
          <li class="nav-item">
            <a href="/multimedia" class="nav-link ">Multimedia</a>
          </li>
          <li class="">/</li>
          <li class="nav-item">
            <div class="px-3">Resources</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <div class="col ">
      <div class="card border-0 rounded-2 shadow mb-3 p-5">
        <div>
          <h1 class="text-center">Coming Soon</h1>
        </div>
        <div><img src="/assets/images/coming-soon.png" alt="" class="w-100 h-100">
        </div>
      </div>
    </div>
  </div>
</div>

<section class="breadcrumb_section">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="pointer" routerLink="/home"> <span><img src="../../../assets/images/leftArrow.svg" class="me-2"
              alt=""></span></li>
        <li class="breadcrumb-item fs-16 fw-400 pointer" routerLink="/home">Home</li>
        <li class="breadcrumb-item fs-16 fw-400 active" aria-current="page">{{activeContainer == 1 ? 'Circulars & Information' : 'Resource Center'}}</li>
      </ol>
    </nav>
    <div class="d-flex">
      <div
        *ngFor="let btn of containers"
        class="btn btn_tabs d-flex align-items-center me-3"
        [ngClass]="activeContainer?.submodule == btn.submodule ? 'active' : ''"
        (click)="changeContainer(btn)
        ">
        <svg
        *ngIf="btn.module == '31'"
        class="tabs_icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.50065 1.66667C9.50065 1.62246 9.48309 1.58007 9.45184 1.54882C9.42058 1.51756 9.37819 1.5 9.33398 1.5H4.66732C4.18109 1.5 3.71477 1.69315 3.37096 2.03697C3.02714 2.38079 2.83398 2.8471 2.83398 3.33333V12.6667C2.83398 13.1529 3.02714 13.6192 3.37096 13.963C3.71477 14.3068 4.18109 14.5 4.66732 14.5H11.334C11.8202 14.5 12.2865 14.3068 12.6303 13.963C12.9742 13.6192 13.1673 13.1529 13.1673 12.6667V6.098C13.1673 6.0538 13.1498 6.01141 13.1185 5.98015C13.0872 5.94889 13.0449 5.93133 13.0007 5.93133H10.0007C9.86804 5.93133 9.74087 5.87865 9.6471 5.78489C9.55333 5.69112 9.50065 5.56394 9.50065 5.43133V1.66667ZM10.0007 8.16667C10.1333 8.16667 10.2604 8.21935 10.3542 8.31311C10.448 8.40688 10.5007 8.53406 10.5007 8.66667C10.5007 8.79928 10.448 8.92645 10.3542 9.02022C10.2604 9.11399 10.1333 9.16667 10.0007 9.16667H6.00065C5.86804 9.16667 5.74087 9.11399 5.6471 9.02022C5.55333 8.92645 5.50065 8.79928 5.50065 8.66667C5.50065 8.53406 5.55333 8.40688 5.6471 8.31311C5.74087 8.21935 5.86804 8.16667 6.00065 8.16667H10.0007ZM10.0007 10.8333C10.1333 10.8333 10.2604 10.886 10.3542 10.9798C10.448 11.0735 10.5007 11.2007 10.5007 11.3333C10.5007 11.4659 10.448 11.5931 10.3542 11.6869C10.2604 11.7807 10.1333 11.8333 10.0007 11.8333H6.00065C5.86804 11.8333 5.74087 11.7807 5.6471 11.6869C5.55333 11.5931 5.50065 11.4659 5.50065 11.3333C5.50065 11.2007 5.55333 11.0735 5.6471 10.9798C5.74087 10.886 5.86804 10.8333 6.00065 10.8333H10.0007Z" />
        <path
        d="M10.5 1.88247C10.5 1.75981 10.6287 1.68181 10.724 1.75848C10.8047 1.82381 10.8773 1.89981 10.9393 1.98648L12.948 4.78448C12.9933 4.84848 12.944 4.93114 12.8653 4.93114H10.6667C10.6225 4.93114 10.5801 4.91358 10.5488 4.88233C10.5176 4.85107 10.5 4.80868 10.5 4.76447V1.88247Z"
        fill="white" />
        </svg>

        <svg class="tabs_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" *ngIf="btn.module == '29'"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1297_7390)">
              <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.99935 1.33398V5.66732C7.99935 5.93253 8.10471 6.18689 8.29224 6.37442C8.47978 6.56196 8.73413 6.66732 8.99935 6.66732H13.3327V13.334C13.3327 13.6876 13.1922 14.0267 12.9422 14.2768C12.6921 14.5268 12.353 14.6673 11.9993 14.6673H3.99935C3.64573 14.6673 3.30659 14.5268 3.05654 14.2768C2.80649 14.0267 2.66602 13.6876 2.66602 13.334V2.66732C2.66602 2.3137 2.80649 1.97456 3.05654 1.72451C3.30659 1.47446 3.64573 1.33398 3.99935 1.33398H7.99935ZM9.99935 10.0007H5.99935C5.82254 10.0007 5.65297 10.0709 5.52794 10.1959C5.40292 10.3209 5.33268 10.4905 5.33268 10.6673C5.33268 10.8441 5.40292 11.0137 5.52794 11.1387C5.65297 11.2637 5.82254 11.334 5.99935 11.334H9.99935C10.1762 11.334 10.3457 11.2637 10.4708 11.1387C10.5958 11.0137 10.666 10.8441 10.666 10.6673C10.666 10.4905 10.5958 10.3209 10.4708 10.1959C10.3457 10.0709 10.1762 10.0007 9.99935 10.0007ZM6.66602 7.33398H5.99935C5.82254 7.33398 5.65297 7.40422 5.52794 7.52925C5.40292 7.65427 5.33268 7.82384 5.33268 8.00065C5.33268 8.17746 5.40292 8.34703 5.52794 8.47206C5.65297 8.59708 5.82254 8.66732 5.99935 8.66732H6.66602C6.84283 8.66732 7.0124 8.59708 7.13742 8.47206C7.26244 8.34703 7.33268 8.17746 7.33268 8.00065C7.33268 7.82384 7.26244 7.65427 7.13742 7.52925C7.0124 7.40422 6.84283 7.33398 6.66602 7.33398ZM9.33268 1.36265C9.58527 1.41622 9.81687 1.54198 9.99935 1.72465L12.942 4.66732C13.1247 4.8498 13.2504 5.0814 13.304 5.33398H9.33268V1.36265Z" />
          </g>
          <defs>
              <clipPath id="clip0_1297_7390">
              <rect width="16" height="16" fill="white" />
              </clipPath>
          </defs>
        </svg>

        <svg class="tabs_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="btn.module == '28'">
          <path d="M2.66732 14C2.30065 14 1.98687 13.8696 1.72598 13.6087C1.4651 13.3478 1.33443 13.0338 1.33398 12.6667V4.66667C1.33398 4.3 1.46465 3.98622 1.72598 3.72533C1.98732 3.46444 2.3011 3.33378 2.66732 3.33333H4.76732L6.00065 2H10.0007L11.234 3.33333H13.334C13.7007 3.33333 14.0147 3.464 14.276 3.72533C14.5373 3.98667 14.6678 4.30044 14.6673 4.66667V12.6667C14.6673 13.0333 14.5369 13.3473 14.276 13.6087C14.0151 13.87 13.7011 14.0004 13.334 14H2.66732ZM5.33398 11.3333H10.6673V10.9667C10.6673 10.4667 10.4229 10.0696 9.93398 9.77533C9.4451 9.48111 8.80065 9.33378 8.00065 9.33333C7.20065 9.33333 6.55621 9.48067 6.06732 9.77533C5.57843 10.07 5.33398 10.4671 5.33398 10.9667V11.3333ZM8.00065 8.66667C8.36732 8.66667 8.68132 8.53622 8.94265 8.27533C9.20398 8.01444 9.33443 7.70044 9.33398 7.33333C9.33398 6.96667 9.20354 6.65289 8.94265 6.392C8.68176 6.13111 8.36776 6.00044 8.00065 6C7.63398 6 7.32021 6.13067 7.05932 6.392C6.79843 6.65333 6.66776 6.96711 6.66732 7.33333C6.66732 7.7 6.79798 8.014 7.05932 8.27533C7.32065 8.53667 7.63443 8.66711 8.00065 8.66667Z" />
        </svg>

        &nbsp;
      {{btn.title}}
    </div>
    </div>
  </div>
</section>

<ng-container [ngTemplateOutlet]="circularInfo" *ngIf="activeContainer?.submodule=='32' && !showDetailsPage">
</ng-container>
<ng-container [ngTemplateOutlet]="caseStudies" *ngIf="activeContainer?.submodule=='40' && !showDetailsPage">
</ng-container>
<ng-container [ngTemplateOutlet]="wallFame" *ngIf="activeContainer?.submodule=='29' && !showDetailsPage">
</ng-container>

<!-- <ng-container [ngTemplateOutlet]="shg"  *ngIf="activeContainer==3">
</ng-container> -->

<ng-template #circularInfo>
  <section class="main px-65">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <h5 class="fs-24 fw-400 col-auto">Circulars & Information</h5>
        <div class="d-flex justify-content-end col">
          <div class="position-relative me-3">
            <img src="../../../../assets/images/search-shg.svg" class="img-fluid searchIcon position-absolute" alt="">
            <input type="search" class="form-control search" #input (keydown.Enter)="search(input)" placeholder="Search by title">
          </div>
          <div class="position-relative me-3 date-range">
            <mat-form-field appearance="standard" class="example-form-field">
              <mat-date-range-input
                [formGroup]="filterDate"
                [rangePicker]="rangePicker1"
                [comparisonStart]="filterDate.value.start"
                [comparisonEnd]="filterDate.value.end"
                [max]="maxDate"
                >
                <input matStartDate placeholder="From" formControlName="start">
                <input matEndDate placeholder="To" formControlName="end">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="rangePicker1"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker1>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply (click)="search(input)">Apply</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="restart d-flex align-items-center justify-content-center bg-white me-3" (click)="resetSearch(input)">
            <img src="assets/images/restartIcon-shg.svg" class="img-fluid" alt="">
          </div>
          <!-- <div class="card_view d-flex justify-content-center align-items-center bg-white">
            <img src="assets/images/gridIcon-shg.svg" (click)="showGridView()" width="20" class="img-fluid pointer"
              alt="">
            <div class="border_div mx-2"></div>
            <img src="assets/images/listIcon-shg.svg" (click)="showListView()" width="20" class="img-fluid pointer"
              alt="">
          </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-start ">
                <!-- [itemSize]="itemSizeVal" -->

                <app-paginator
                  [totalCount]="itemSizeVal"
                  [page]="page"
                  (nextPage)="pageEvent($event)"
                ></app-paginator>
              </div>
              <div class="table-responsive">
                <table class="table table-borderless table-hover">
                  <thead style="background-color: #EFEFEF;">
                    <tr>
                      <th class="color-grey">S.No.</th>
                      <th class="color-grey">Title</th>
                      <th class="color-grey">Description</th>
                      <th class="color-grey">Uploaded Date</th>
                      <!-- <th class="color-grey">Source</th> -->
                      <th class="color-grey">Uploaded By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-bottom" *ngFor="let d of circularCard; let i = index" (click)="navigateToDetails(d)">
                      <td class="cursor-pointer">{{(page-1) * 20 + i + 1}}</td>
                      <td class="cursor-pointer">{{d?.title | slice: 0 : 20 }}{{d?.title?.length > 20 ? '...':''}}</td>
                      <td class="cursor-pointer">{{d?.description | slice: 0 : 20 }}{{d?.description?.length > 20 ? '...':''}}</td>
                      <td class="cursor-pointer">{{d?.publishedDate | date : 'd/M/yy'}}</td>
                      <!-- <td class="cursor-pointer">{{d?.source}}</td> -->
                      <td class="cursor-pointer">{{d?.publishedBy | slice: 0 : 20 }}{{d?.publishedBy?.length > 20 ? '...':''}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>


<!-- Case Study -->
<ng-template #caseStudies>
  <section class="main px-65">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <h5 class="fs-24 fw-400 col-auto">Case Studies</h5>
        <div class="d-flex justify-content-end col">
          <div class="position-relative me-3">
            <img src="../../../../assets/images/search-shg.svg" class="img-fluid searchIcon position-absolute" alt="">
            <input type="search" class="form-control search" #input (keydown.Enter)="search(input)" placeholder="Search by title">
          </div>
          <div class="position-relative me-3 date-range">
            <mat-form-field appearance="standard" class="example-form-field">
              <mat-date-range-input [rangePicker]="rangePicker"
                [formGroup]="filterDate"
                [rangePicker]="rangePicker"
                [comparisonStart]="filterDate.value.start"
                [comparisonEnd]="filterDate.value.end"
                [max]="maxDate"
                >
                <input matStartDate placeholder="From" formControlName="start">
                <input matEndDate placeholder="To" formControlName="end">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply (click)="search(input)">Apply</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="restart d-flex align-items-center justify-content-center bg-white me-3" (click)="resetSearch(input)">
            <img src="assets/images/restartIcon-shg.svg" class="img-fluid" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-start ">
                <!-- Test Element -->
                <app-paginator
                  [totalCount]="itemSizeVal"
                  [page]="page"
                  (nextPage)="pageEvent($event)"
                ></app-paginator>
              </div>
              <div class="table-responsive">
                <table class="table table-borderless table-hover">
                  <thead style="background-color: #EFEFEF;">
                    <tr>
                      <th class="color-grey">S.No.</th>
                      <th class="color-grey">Case Study Name</th>
                      <th class="color-grey">Uploaded Date</th>
                      <!-- <th class="color-grey">Source</th> -->
                      <th class="color-grey">Uploaded By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let c of studyCard; let i = index"
                      (click)="navigateToCaseStudy(c)"
                      class="cursor-pointer border-bottom"
                      >
                      <td>{{ (page -1)*20 + i+1}}</td>
                      <td>{{c?.title}}</td>
                      <td>{{c?.publishedDate | date : 'd/M/yy'}}</td>
                      <!-- <td>{{c?.source}}</td> -->
                      <td>{{c?.publishedBy}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>


<ng-template #wallFame>
  <section class="main px-65">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <h5 class="fs-24 fw-400 col-auto">Wall of Fame</h5>
        <div class="d-flex justify-content-end col">
          <div class="position-relative me-3">
            <img src="../../../../assets/images/search-shg.svg" class="img-fluid searchIcon position-absolute" alt="">
            <input type="search" class="form-control search" #input (keydown.Enter)="search(input)" placeholder="Search by title">
          </div>
          <div class="position-relative me-3 date-range">
            <mat-form-field appearance="standard" class="example-form-field">
              <mat-date-range-input [rangePicker]="rangePicker"
                [formGroup]="filterDate"
                [rangePicker]="rangePicker"
                [comparisonStart]="filterDate.value.start"
                [comparisonEnd]="filterDate.value.end"
                [max]="maxDate"
                >
                <input matStartDate placeholder="From" formControlName="start">
                <input matEndDate placeholder="To" formControlName="end">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply (click)="search(input)">Apply</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="restart d-flex align-items-center justify-content-center bg-white me-3" (click)="resetSearch(input)">
            <img src="assets/images/restartIcon-shg.svg" class="img-fluid" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let item of sliderImage" (click)="navigateToWallFameDetailsPage(item)">
          <div class="card user_card border-0 shadow-sm mb-3 br-4">
            <div class="overlay_div">
              <img [src]="item?.fileList[0]?.fileUrl" class="img-fluid user_image w-100 br-4" alt="img">
            </div>
            <div class="card-body">
              <h6 class="fs-16 fw-600 mb-2">{{item.title}}</h6>
              <span class="fs-12 fw-400 color-grey"><img src="/assets/images/locationIcon-shg.svg" width="12" class="img-fluid" alt="location"/>{{item?.documentSource}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>

<div *ngIf="showDetailsPage">
  <section class="wallFame product">
    <div class="container-fluid row">
      <div class="col-lg-6">
        <h5 class="fs-24 fw-400 col-auto mt-3">{{wallFameDetails?.title}}</h5>
        <div style="display: flex;">
          <img src="../../../../assets/location.png" alt="location" style="width: 17px;
          height: 17px;
          margin-top: 8px;" />
          <p style="font-size: 12px; margin: 0;" class="mt-2">{{wallFameDetails?.documentSource ? wallFameDetails?.documentSource : 'Uttar Pradesh'}}</p>
        </div>
        <div style="background-color: white;" class="mt-3 mb-3 p-2">
          <p style="margin: 0; font-weight: 700;">Description</p>
          <p style="margin: 0; font-size: 12px; color: gray;" class="pt-2">{{wallFameDetails?.description ? wallFameDetails?.description : 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.'}}</p>
        </div>
      </div>
      <div class="col-lg-6">
        <img [src]="wallFameDetails?.fileList[0].fileUrl" alt="image" style="width: 100%; height: 550px;" />
      </div>
    </div>
    <section class="slider_section" style="margin-top: 70px;">
      <div class="text-center fs-24 fw-400 mb-4">Other Stories</div>
      <div class="container-fluid pe-0 overflow-hidden">
        <div class="slider-wrap">
          <!-- style="display: flex; overflow-x: auto;" -->
          <div class="slider-main d-flex gap-2 flex-nowrap">
            <div style="border-radius: 5px; cursor: pointer" class="item col-lg-3 mb-4" *ngFor="let item of sliderImage" (click)="navigateToWallFameDetailsPage(item)">
              <div style="width: 100%;">
                <img [src]="item?.fileList[0]?.fileUrl" class="img-fluid w-100 slider-img br-4" alt="img">
              </div>
              <div class="detail">
                <div class="name fs-16 fw-600">{{item.title}}</div>
                <div class="designation fs-12 fw-400 color-grey mb-1">{{item.documentSource}}</div>
              </div>
            </div>
          </div>
    
          <div class="button_area d-flex">
            <button class="btn prev text-white" (click)="previousSlideWallFrame()">
              <img src="../../../../assets/images/prevIcon-shg.svg" class="img-fluid" alt="">
            </button>
            <button class="btn next text-white" (click)="nextSlideWallFrame()">
              <img src="../../../../assets/images/nextIcon-svg.svg" class="img-fluid" alt="">
            </button>
          </div>
        </div>
      </div>
    </section>
  </section>
</div>
